// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import toast from "./utils/toast";
import Axios from 'axios'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
// import Vconsole from 'vconsole';
// new Vconsole();
Vue.prototype.$axios = Axios
Vue.prototype.$video = Video

// step3：使每次请求都会带一个 /api 前缀
Axios.defaults.baseURL = '/api'

Vue.config.productionTip = false
Vue.use(toast)
// 设置title
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})




//时间显示问题（几天前、几分钟前）
Vue.filter('yq_formatTime', function (valueTime) {

  if (valueTime) {
    var newData = new Date()
    var targetDate = new Date(valueTime)
    var diffTime = Math.abs(newData - targetDate)

    console.log('valueTime: ', valueTime, targetDate)

    if (diffTime > 3 * 24 * 3600 * 1000) {
      var date = new Date(valueTime)

      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      var h = date.getHours()
      h = h < 10 ? ('0' + h) : h
      var minute = date.getMinutes()
      var second = date.getSeconds()
      minute = minute < 10 ? ('1' + minute) : minute
      second = second < 10 ? ('0' + second) : second
      return m + '-' + d + ' ' + h + ':' + minute

    } else if (diffTime <= 3 * 24 * 3600 * 1000 && diffTime > 24 * 3600 * 1000) {
      // //注释("一周之内");

      // var time = newData - diffTime;
      var dayNum = Math.floor(diffTime / (24 * 60 * 60 * 1000))
      return dayNum + '天前'

    } else if (diffTime <= 24 * 3600 * 1000 && diffTime > 3600 * 1000) {
      // //注释("一天之内");
      // var time = newData - diffTime;
      var dayNum = Math.floor(diffTime / (60 * 60 * 1000))
      return dayNum + '小时前'

    } else if (diffTime <= 3600 * 1000 && diffTime > 180) {
      // //注释("一小时之内");
      // var time = newData - diffTime;
      var dayNum = Math.floor(diffTime / (60 * 1000))
      return dayNum + '分钟前'
    } else if (diffTime <= 180 * 1000 && diffTime > 0) {
      // //注释("刚刚");
      return '刚刚'
    } else {
      return valueTime
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js